import { signal } from '@preact/signals';

export const appLocked = signal(true);
export const privateUnlocked = signal(false);
export const biometricOffer = signal<'app' | 'private' | null>(null);
